import Link from '@Components/common/Link';
import styled, { css } from 'styled-components';
import { mq, rgba } from 'stylesheets/utils';
export const Section = styled.div`
  padding: 16px 50px 60px 50px;
  border: 1px solid ${({ theme }) => theme.colors.innerProduct.lightGray};
  border-radius: 4px;
  margin: 35px 0 26px 0;
  position: relative;
  ${mq(1200)} {
    padding: 16px;
  }
`;

export const Badge = styled.div`
  position: absolute;
  top: -1px;
  right: -1px;
  background-color: ${({ theme }) => theme.colors.yellow};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  /* line-height: 36px; */
  border-top-right-radius: 4px;
  border-bottom-left-radius: 4px;
  color: ${({ theme }) => theme.colors.black2};
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  z-index: 5;
  line-height: 0.9;
  span {
    font-size: ${({ theme }) => theme.fontsizes.body12};
    font-weight: ${({ theme }) => theme.fontWeight.font400};
    color: inherit;
    margin-top: 8px;
  }
`;

export const MoreArrow = styled.div`
  max-width: 24px;
  min-width: 24px;
  max-height: 24px;
  min-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: none /*rtl: scale(-1, 1) */;
  margin-left: 2px;
`;

export const More = styled(Link)`
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  color: ${({ theme }) => theme.colors.cartCountColor};
  font-size: ${({ theme }) => theme.fontsizes.body14};
  display: flex;
  align-items: center;
  cursor: pointer;
  line-height: 24px;
  /* margin: 0 auto; */
`;

export const NotCompatible = styled.p`
  display: flex;
  align-items: center;
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  font-size: ${({ theme }) => theme.fontsizes.body14};
  color: ${({ theme }) => theme.colors.gray};
`;

export const CloseIcon = styled.div`
  max-width: 20px;
  min-width: 20px;
  max-height: 20px;
  min-height: 20px;
  margin-left: 10px;
  cursor: pointer;
`;

export const BrowseBar = styled.div<{
  readonly compatible?: boolean | undefined;
}>`
  padding: 8px 30px;
  width: calc(100% - 24px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.lightBlue};
  ${({ compatible }) =>
    compatible &&
    css`
      background-color: ${({ theme }) => rgba(theme.colors.green, 0.1)};
    `}
  ${mq(576)} {
    padding: 8px;
    width: calc(100% - 34px);
  }
`;
